import React from 'react';
import { Text as RNText, TextProps as RNTextProps } from 'react-native';
import s, { getFontFamily } from './Typography.styles';

export type Caption2Props = RNTextProps & {
  weight?: 'regular' | 'medium' | 'semibold';
  uppercase?: boolean;
};

export const Caption2: React.FC<Caption2Props> = ({
  children,
  weight = 'regular',
  uppercase = false,
  style,
  ...props
}) => {
  return (
    <RNText
      style={[
        s.common,
        s.caption2,
        uppercase && s.caption2Caps,
        {
          textTransform: uppercase ? 'uppercase' : 'none',
        },
        getFontFamily(weight),
        style,
      ]}
      {...props}
    >
      {children}
    </RNText>
  );
};
